import { Actions as GlobalActions } from 'pages/_store/global/actions';
import { Dispatch } from 'utils/action-utils';

const getUserConfirmation = (dispatch: Dispatch) => (message: string, callback: (ok: boolean) => void) => {
  dispatch(GlobalActions.openConfirmationModal(callback));
};

export default getUserConfirmation;
